module.exports = __webpack_public_path__ + "static/media/addyPic2.0b04de6d.jpg";